<template>
    <div class="container feedback template-bg-gray">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec">
                <div class="loop_container bg-transparent update-request-form-common">
                    <div class="card form-wrapper" v-bind:class="{'thankupageplr88': success}">
                        <div class="feedback_container">
                            <div style="display: grid; place-items: center;">
                                <img :src="logoURL" :alt="'Community Logo of '+ community.content.parameter4"
                                    :style="{ width: '128px', maxHeight: '128px' }">
                            </div>
                            <template v-if="success === false">
                                <header aria-live="polite">
                                    <h1 class="template-title text-center common-space-from-logo mb10">Sorry to see you
                                        go!
                                    </h1>
                                    <p class="custom-content my-text-center mb30" tabindex="0">Complete the below form to unsubscribe
                                        from {{ community.content.parameter2 }}</p>
                                </header>
                                <form @submit.prevent="unsubscribeUser" class="template-form">
                                    <p class="required-note template-label" id="required-note">
                                        Fields marked with an asterisk (<span class="required-symbol">*</span>) are
                                        required.
                                    </p>
                                    <div class="row">
                                        <div class="col-md-6 mr-1 mb-17">
                                            <div class="input-group">
                                                <label class="template-label" for="unsusbcribe-email">Email</label><span
                                                    class="required-symbol"> *</span>
                                                <input type="text" id="unsusbcribe-email"
                                                    class="form-control input-value pt-input w-100 input-focus"
                                                    :class="[{'b-error': errors.has('email')}, 'form-control', 'pt-input', 'input-focus']"
                                                    name="email" v-model="email" v-validate="'required|email|max:60'"
                                                    required
                                                    :aria-invalid="errors.has('email')" aria-describedby="email-error"
                                                    aria-required="true">
                                                <p id="email-error" class="error" v-show="errors.has('email')"
                                                    role="alert">
                                                    {{ errors.first('email') }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-35">
                                            <div class="input-group">
                                                <label class="template-label" for="unsusbcribe-combobox">Unsubscribe
                                                    Reason</label>
                                                <select id="unsusbcribe-combobox"
                                                    class="form-control mb-16 pt-input input-focus input-focus select-dropdown requestPageDropdown template-dform-control input-value pt-input w-100 input-focus"
                                                    name="reason" v-model="reason">
                                                    <option value="" disabled selected hidden>Can you tell us why?
                                                    </option>
                                                    <option value="Don't have time">Don't have time</option>
                                                    <option value="Not relevant to me">Not relevant to me</option>
                                                    <option value="Poor experience">Poor experience</option>
                                                    <option value="Too many emails">Too many emails</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                <p class="error" v-show="errors.has('reason')">
                                                    {{errors.first('reason')}}</p>
                                                <!--  <select class="form-control pt-input" v-model="reason">
                                                    <option value="" disabled selected hidden>Can you tell us why?</option>
                                                    <option value="Don't have time">Don't have time</option>
                                                    <option value="Not relevant to me">Not relevant to me</option>
                                                    <option value="Poor experience">Poor experience</option>
                                                    <option value="Too many emails">Too many emails</option>
                                                    <option value="Other">Other</option>
                                                </select> -->
                                            </div>
                                        </div>
                                        <div class="col-md-12 mt-6">
                                            <div
                                                class="input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2">
                                                <label class="template-label" for="description-field">Tell us more about
                                                    your experience</label>
                                                <textarea type="text" id="description-field"
                                                    class="form-control placeholder-bold"
                                                    aria-describedby="description-help description-counter" rows="5"
                                                    cols="5" v-model="description" name="description"
                                                    placeholder="Is there anything else you'd like us to know?"
                                                    v-validate.continues="'max:500'"
                                                    aria-label="Unsubscribe reason - maximum 500 characters"
                                                    v-on:keyup="countdown" :maxlength="max"
                                                    v-bind:class="{'request-form-error-border': errors.has('description') }"></textarea>
                                                <div class="form-group  pd-remove unsubscribe-btn mb-0-custom">
                                                    <div class="char-counter template-subject-counter"
                                                        v-bind:class="{'char-count-error': exceedsMaxCount }">
                                                        {{remainingCount}} / 500</div>
                                                </div>
                                                <p id="description-help" class="sr-only">Please provide details about
                                                    your experience (500 characters maximum)</p>
                                            </div>
                                            <p class="error" v-show="errors.has('description')">
                                                {{errors.first('description')}}</p>
                                        </div>
                                    </div>
                                    <div class="btn-block text-right mlr0">
                                        <md-button v-bind:style="unsubscribeBtn" type="submit" name="unsubscribe"
                                            class="btn template-review-submit template-button template-button-width mlr0">Unsubscribe
                                        </md-button>
                                    </div>
                                </form>
                            </template>
                            <template v-else>
                                <div class='header-text'>
                                    <h1 class="template-title my-text-center common-space-from-logo">Thank you!</h1>
                                    <p class="box-sub-heading mb35 custom-content my-text-center">You have successfully
                                        unsubscribed.</p>
                                </div>
                            </template>
                        </div>
                    </div>
                    <ul class="list-inline text-center footer-links">
                        <li>
                            <a :href="community.content.landingPageURL" target="_blank" class="links"
                                v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length"
                                tabindex="0">Learn More</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                        </li>
                        <li>
                            <a :href="community.content.termsConditionsURL" target="_blank" class="links"
                                v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length"
                                tabindex="0">Terms Of Use [pdf]</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                        </li>
                        <!-- <li>
                            <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                            <a href="javascript:void(0)" v-else>Opt Out</a>
                        </li> -->
                    </ul>
                    <div class="unsubscribe-community-logo">
                        <a href="https://www.protopia.co" target="_blank"><img loading="lazy" :src="this.footerLogoURL"
                                :alt="'Community Logo of '+ community.content.parameter4"><span class="sr-only">Protopia
                                - Visit our site</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from "../services/API";
import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";
export default {
    name: 'MemberUnsubscribe',
    data() {
        return {
            api: new API(),
            memberId: null,
            email: '',
            reason: '',
            description: '',
      		fullPage: true,
            success: false,
            community: {},
            exceedsMaxCount: false,
			max: 500,
            remainingCount: 0,
            unsubscribeBtn: {
                border: '1px solid #9178A0',
                color: '#9178A0',
                background: '#fffff'
            },
            logoURL: '',
            imgAlt: 'Community Logo',
            footerLogo: "",
            footerLogoURL: "",
        }
    },
    created() {
        if (!this.$route.params.community_code) {
            this.$router.push('/');
        }
        this.loadData();
        const dict = {
			 custom: {
			    email: {
			      required: 'Please enter your email',
			      email: 'Please enter valid email address',
			      max: 'email address may not be greater than 60 characters'
			    },
                reason: {
			      required: 'Please select a reason'
			    }
			 }
	  	};
	  	this.$validator.localize('en', dict);
    },
    watch: {
        email(newEmail) {
        // Simple email regex pattern
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            // Check if the new email value matches the email format
            if (emailPattern.test(newEmail)) {
                console.log("A valid email was entered:", newEmail);
                // Call checkMemberStatus with the new email
                this.checkMemberStatus(newEmail);
            }
        }
  },
    methods: {
        loadData: async function() {
            localStorage.setItem('community_id', this.$route.params.community_code);
            await this.$nextTick(); // Ensure localStorage is committed before API calls
            await this.api.get(`communities/${this.$route.params.community_code}`).then(response => {
                if (response.data) {
                    this.community = response.data;
                    const customSettings = this.community.customSettings;
                    this.reviewBtn = {
                        border: '1px solid ' + response.data.customSettings.primaryBtnBgColor,
                        color: response.data.customSettings.primaryBtnBgColor
                    };
                    this.unsubscribeBtn = {
                        border: '1px solid ' + response.data.customSettings.primaryBtnBgColor,
                        color: response.data.customSettings.primaryTxtColor,
                        background: response.data.customSettings.primaryBtnBgColor,
                    };
                    if (this.community && this.community.content.parameter2) {
                        this.imgAlt = this.community.content.parameter2;
                    }
                    this.logoURL = getLogoURL(customSettings);
                    this.footerLogoURL = getFooterURL(customSettings);
                }
            });
        },
        unsubscribeUser: async function(event) {
            const isValid = await this.$validator.validateAll();
            if (!isValid) {
                const firstError = this.errors.items[0];
                const firstInvalidField = document.querySelector(
                    `[name="${firstError.field}"]`
                );

                if (firstInvalidField) {
                    firstInvalidField.focus();
                    const alertMsg = `Error: ${firstError.msg}`;
                    const liveRegion = document.createElement('div');
                    liveRegion.setAttribute('role', 'alert');
                    liveRegion.setAttribute('aria-live', 'assertive');
                    liveRegion.textContent = alertMsg;
                    document.body.appendChild(liveRegion);
                    setTimeout(() => liveRegion.remove(), 5000);
                }
            }
            else {
                var unsubscribe = {
                    email: this.email,
                    reason: this.reason,
                        description: this.description
                    }
                    // source: the member opted out themselves (api member/unsubscribeSource.js)
                    await this.api.post('members/unsubscribe', {unsubscribe: unsubscribe, community: this.$route.params.community_code, isMailSent: true, memberId: this.memberId, source: 'member_form'}).then(response => {
                        this.email = '';
                        this.reason = '';
                        this.description = '';
                        if (response.data === 'User unsubscribed') {
                            this.success = true;
                        } else {
                            this.$toast.error(response.data);
                        }
                    });
                }
        },
        checkMemberStatus: function(email) {
            let params = {
                email: email,
                community_id: this.$route.params.community_code
            }
            this.api.post(`communities/${this.$route.params.community_code}/get-member-details-unsubscribe/`, params)
                .then(async member => {
                    if (member.data._id) {
                        console.log('member Id', member.data._id)
                        if (member.data.unsubscribe) {
                            this.memberExists = false;
                        } else {
                            this.memberExists = true;
                        }
                        this.memberId = member.data._id;
                    }
            });
        },
        countdown: function() {
            this.remainingCount = this.max - this.description.length;
            this.remainingCount === 0
              ? (this.exceedsMaxCount = true)
              : (this.exceedsMaxCount = false);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/MemberUnsubscribe.vue